"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("clipPath", {
    id: "prefix__a"
  }, (0, _pragma.createFelaElement)("path", {
    d: "M0 0h24v24H0z"
  })), (0, _pragma.createFelaElement)("g", {
    clipPath: "url(#prefix__a)"
  }, (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.733 12.75c-.112 2.421-.746 4.778-1.549 6.684-.442 1.05-.93 1.948-1.398 2.635a6.8 6.8 0 01-.743.93L12 23h-.042a6.808 6.808 0 01-.744-.931c-.468-.687-.955-1.586-1.398-2.635-.803-1.906-1.437-4.263-1.548-6.684zm1.501 0c-.112 2.654-.802 5.212-1.668 7.266a17.11 17.11 0 01-1.463 2.783c4.83-.935 8.534-5.03 8.872-10.049zm0-1.5c-.112-2.654-.802-5.212-1.668-7.266A17.107 17.107 0 0014.103 1.2c4.83.935 8.534 5.03 8.872 10.049zM12.043 1c.217.221.47.53.743.931.468.687.956 1.586 1.398 2.635.803 1.906 1.437 4.263 1.549 6.684H8.268c.111-2.421.745-4.778 1.548-6.684.443-1.05.93-1.948 1.398-2.635.274-.402.526-.71.744-.93L12 1h.043zM1.025 11.25h5.741c.112-2.654.802-5.212 1.668-7.266.452-1.072.957-2.02 1.464-2.783-4.831.935-8.535 5.03-8.873 10.049zm7.41 8.766c-.867-2.054-1.557-4.612-1.669-7.266h-5.74c.337 5.018 4.04 9.114 8.872 10.05a17.105 17.105 0 01-1.464-2.784z",
    clipRule: "evenodd"
  })));
}

var _default = 'src/asset/icon/discover-active.icon.svg';
exports.default = _default;
//# sourceMappingURL=discover-active.icon.js.map